/* External Files */
// jquery helper
import './scripts/jqueryLib.js';

/* Internal Files */
import general from './scripts/general.js';

document.addEventListener('DOMContentLoaded', function () {
    general();
});
